import type { FaireProductEntity } from "../../entity_types/product";

export const p_ce7gutr286: FaireProductEntity = {
  token: "p_ce7gutr286",
  type: "product",
  name: "Vintage Pink Parisian Glass Fragrance Warmer",
  brandName: "Candle Warmers Etc.",
  imageUrl:
    "https://cdn.faire.com/fastly/ed8ae830c076a4581e4a63b89f78c779bdc0f535a804def8df07271913a5505e.jpeg",
  priceDollars: 14.3,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/552cddc9c1b427d413f247f4d374d809a63a92678b58b7b1619e90897391b5fb.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
